var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBolso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 18.7469C25 24.4954 19.793 27.0795 12.501 27.0795C5.2089 27.0795 0 24.4954 0 18.7875C0 13.3233 2.38878 10.2149 7.16634 7.4045C8.70604 8.56146 10.5802 9.18637 12.5061 9.18498C14.4321 9.18358 16.3053 8.55595 17.8433 7.39676C22.6151 10.1782 25 13.2865 25 18.7469ZM15.8723 5.81843L18.3288 1.97897C18.4349 1.77519 18.4874 1.54778 18.4813 1.31813C18.4753 1.08848 18.4109 0.864141 18.2943 0.666232C18.1776 0.468323 18.0125 0.303352 17.8145 0.186843C17.6165 0.070334 17.3921 0.00611973 17.1625 0.000243544H8.32882C8.08381 -0.00440365 7.84213 0.0575329 7.62955 0.179449C7.41697 0.301365 7.24146 0.478689 7.12175 0.692513C7.00203 0.906338 6.94259 1.14864 6.94976 1.3936C6.95693 1.63855 7.03045 1.87696 7.16248 2.08342L9.18762 5.85518C11.2398 7.08342 13.8298 7.07181 15.8723 5.81843Z",
    fill: "#F7F2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBolso);
export default __webpack_public_path__ + "static/media/ic_bolso.8abef6d92d3d10d88649d2178089af4e.svg";
export { ForwardRef as ReactComponent };